// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","grey-medium":"#5e5e5e","fieldset":"_3TXJE_v","fadeIn":"_39k-zuN","cancel":"_75gzKu0","button":"s5x8Lyz"};